import { clsx } from 'clsx';
import type { StatutZone } from '@/types';
import { STATUT_ZONE_LABELS, STATUT_ZONE_COLORS } from '@/types';

interface ZoneStatusBadgeProps {
  statut: StatutZone;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Badge affichant le statut d'une zone de deneignement
 * SFD v2.1: Couleurs distinctes pour chaque statut
 */
export function ZoneStatusBadge({ statut, size = 'md', className }: ZoneStatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full text-white',
        STATUT_ZONE_COLORS[statut],
        sizeClasses[size],
        className
      )}
    >
      {STATUT_ZONE_LABELS[statut]}
    </span>
  );
}

export default ZoneStatusBadge;
